import { additionalOffsetTop } from "./modules/animation.js";

(function () {
  /**
   * Fonction pour défiler automatiquement au chargement de la page
   * jusqu'à l'élément avec un Id spécifique.
   */
  const scrollingAuto = () => {
    const scrollingAutoElement = document.getElementById("js-scrolling-auto");
    if (!scrollingAutoElement) {
      return null;
    }

    const behavior = scrollingAutoElement.getAttribute("data-behavior");
    const hasFixedNav = !!document.querySelector(FIXEDNAV);

    setTimeout(() => {
      // retourner getBoundingClientRect au lieu d'offsetTop à cause d'Elementor
      let scrollingAutoElemOffsetTop = scrollingAutoElement.getBoundingClientRect().top + window.scrollY;
      scrollingAutoElemOffsetTop += additionalOffsetTop(true, hasFixedNav ? ".js-fixedNav, .js-navbar" : NAVBAR);

      // Ajouter -1px à la position top pour éviter un changement de hauteur à fixedNav suite au défilement
      // Voir scrollAnchor.js et la CSS de .ux-fixed.is-active
      window.scrollTo({
        top: scrollingAutoElemOffsetTop + 1,
        behavior: behavior ? behavior : "smooth",
      });
    }, 500);
  };

  /**
   * Fonction pour détecter si un élément contient du contenu qui déborde
   * de son parent. Si oui, on active le style pour afficher une scrollbar
   */
  const overflowContent = () => {
    const elements = document.querySelectorAll(".ux-customScroll-v");

    elements.forEach((element) => {
      if (element.parentElement.clientHeight < element.clientHeight) {
        element.classList.add("is-active");
      } else {
        element.classList.remove("is-active");
      }
    });
  };

  window.addEventListener("load", () => {
    scrollingAuto();
    overflowContent();
  });

  // Appeler la fonction nécessaire au resize de la page
  window.addEventListener("resize", () => {
    overflowContent();
  });
})();
